@use "../../styles/breakpoint.module.scss" as *;

.root {
    composes: repeater from "../../styles/layout.module.scss";
    grid-column: content;
}

.disclosureGroup {
    composes: repeater from "../../styles/layout.module.scss";
}

.disclosure {
    display: grid;
    grid-column: content-start / content-end;
    grid-template-columns: subgrid;
    border-bottom: 1px solid var(--mid-gray);

    &:first-child {
        border-top: 1px solid var(--mid-gray);
    }
}

.heading {
    composes: repeater from "../../styles/layout.module.scss";
}

.trigger {
    grid-column: col-start 2 / col-end 11;
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    gap: var(--spacer-24);
    padding: var(--spacer-40) 0;
    background: none;
    border: none;
    cursor: pointer;
    text-align: left;
    transition: opacity 0.3s ease;

    @media ($below-tablet) {
        grid-column: content-start / content-end;
    }

    &:hover {
        opacity: 0.8;
    }

    &:focus-visible {
        outline: 2px solid var(--black);
        outline-offset: 2px;
    }
}

.question {
    composes: fontHB48 from "../../styles/typography.module.scss";
    flex: 1;
    color: var(--black);

    @media ($below-tablet) {
        font: var(--font-hb-40);
    }

    @media ($below-mobile) {
        font: var(--font-hb-32);
    }
}

.arrow {
    flex-shrink: 0;
    width: 16px;
    height: 16px;
    // Center within first line: (font-size × line-height - arrow-size) / 2
    // Desktop: --font-hb-48-lg = 48px / 0.9
    margin-top: calc((48px * 0.9 - 16px) / 2);
    transform: rotate(0deg);
    transition: transform 0.3s ease;
    color: var(--red);

    @media ($below-tablet) {
        margin-top: calc((32px * 0.9 - 16px) / 2);
    }

    @media ($below-mobile) {
        margin-top: calc((24px * 0.9 - 16px) / 2);
    }

    @media (prefers-reduced-motion: reduce) {
        transition: none;
    }

    &.expanded {
        transform: rotate(180deg);
    }
}

.panel {
    display: grid;
    grid-column: 1 / -1;
    grid-template-columns: subgrid;
    height: var(--disclosure-panel-height);
    transition: height 0.3s ease-in-out;
    overflow: clip;

    @media (prefers-reduced-motion: reduce) {
        transition: none;
    }
}

.answer {
    composes: fontP20 from "../../styles/typography.module.scss";
    grid-column: col-start 4 / col-end 9;
    padding-bottom: var(--spacer-40);
    color: var(--black);

    @media ($below-tablet) {
        grid-column: col-start 2 / col-end 11;
    }

    @media ($below-mobile) {
        grid-column: content-start / content-end;
        font: var(--font-p-16);
    }
}
